import React from 'react';
import Orders from 'src/components/Orders';
import ResponsiveWrapper from 'src/components/ResponsiveWrapper';

const ProxyOrders = () => {
    return (
        <ResponsiveWrapper>
            <Orders />
        </ResponsiveWrapper>
    );
};

export default ProxyOrders;
